/* ============================================================
   Zustand-стор нового дизайна «Федерация киберспорта СКО».

   Роут (route) живёт в основном useAppStore — так продолжают
   работать редиректы после логина/логаута и старые страницы
   платформы. Здесь — только UI-состояние новой витрины.
   ============================================================ */
import { create } from 'zustand';
import { useAppStore } from '../store';
import i18n from '../i18n';
import { DICT } from './i18n';
import { useFedContent } from './content';
import { readSessionSelection, saveSessionSelection } from './useSessionSelection';

const initialLang = (() => {
  try {
    const saved = localStorage.getItem('sq_lang');
    return saved === 'kz' ? 'kz' : 'ru';
  } catch (e) {
    return 'ru';
  }
})();

export const useFedStore = create((set, get) => ({
  lang: initialLang,
  langFading: false,
  menuOpen: false,

  // турниры
  tourId: 'fifa-open-2026',
  tourTab: 'overview',
  tourFilter: readSessionSelection('tournaments-filter', 'all'),
  teamJoinCode: '',
  adminSection: 'dash',
  adminEditId: null,
  adminTourTab: 'info',

  // новости
  newsCat: readSessionSelection('news-category', 'all'),
  articleId: 'n1',

  // проекты
  projectId: null,

  // мессенджер: диалог из deep-link/push
  messengerId: null,

  // auth
  authMode: 'login',

  // модалка спонсорства
  sponsorOpen: false,
  sponsorSent: false,
  sponsorType: 'gen',

  // модалка заявки на турнир
  applyOpen: false,
  applySent: false,
  applyTourId: null,

  // возврат после входа/регистрации: {route, extra} (extra — tourId и т.п.)
  authReturn: null,

  /** Переход между страницами витрины (+доп-параметры: tourId, articleId, authMode…) */
  go: (route, extra = {}) => {
    set({ menuOpen: false, ...extra });
    useAppStore.getState().go(route);
  },

  toggleMenu: () => set((s) => ({ menuOpen: !s.menuOpen })),
  closeMenu: () => set({ menuOpen: false }),

  /** Переключение языка RU/KZ — мгновенно, без фейдов и скачков вёрстки */
  toggleLang: () => {
    const next = get().lang === 'ru' ? 'kz' : 'ru';
    set({ lang: next });
    try {
      localStorage.setItem('sq_lang', next);
      i18n.changeLanguage(next); // синхронизируем старые страницы платформы
    } catch (e) {}
  },

  setTourTab: (tourTab) => set({ tourTab }),
  setTeamJoinCode: (teamJoinCode) => set({ teamJoinCode }),
  setTourFilter: (tourFilter) => { saveSessionSelection('tournaments-filter', tourFilter); set({ tourFilter }); },
  setNewsCat: (newsCat) => { saveSessionSelection('news-category', newsCat); set({ newsCat }); },
  setAuthMode: (authMode) => set({ authMode }),
  setSponsorType: (sponsorType) => set({ sponsorType }),

  openSponsor: () => set({ sponsorOpen: true, sponsorSent: false }),
  closeSponsor: () => set({ sponsorOpen: false }),

  openApply: (tourId) => set({ applyOpen: true, applySent: false, applyTourId: tourId }),
  closeApply: () => set({ applyOpen: false }),
  setApplySent: () => set({ applySent: true }),
  setAuthReturn: (authReturn) => set({ authReturn }),

  /** Отправка заявки на спонсорство — в бэкенд (POST /api/sponsors).
      Если бэкенд недоступен: локальная запись + старый канал поддержки,
      чтобы заявка не потерялась. */
  submitSponsor: async (form) => {
    const { sponsorType } = get();
    const payload = {
      name: (form.name || '').trim() || '—',
      phone: (form.phone || '').trim() || '—',
      type: sponsorType,
      message: form.message || '',
    };
    let sent = false;
    try {
      sent = await useFedContent.getState().createSponsorRequest(payload);
    } catch (e) {}
    if (!sent) {
      const typeLabel = { gen: 'Общее', tour: 'Турнир', media: 'Медиа' }[sponsorType] || sponsorType;
      try {
        useFedContent.getState().addSponsorRequest(payload);
      } catch (e) {}
      try {
        await useAppStore.getState().submitSupportTicket({
          name: payload.name,
          email: '',
          phone: payload.phone,
          message: `[СПОНСОРСТВО · ${typeLabel}] ${payload.message}`,
          page: 'partners',
        });
      } catch (e) {}
    }
    set({ sponsorSent: true });
  },
}));

/** Хук: словарь текущего языка */
export function useL() {
  const lang = useFedStore((s) => s.lang);
  return DICT[lang];
}
